import axios from "axios";

export async function logIn(value) {
    return await axios
        .post('https://devapi.oaswitchboard.org/v1/authorize', value)
};
